// extracted by mini-css-extract-plugin
export var alphabetListStyle = "Typography-module--alphabet--list-style--9f76d";
export var blueColor = "Typography-module--blue--color--6c874";
export var boldWeight = "Typography-module--bold--weight--8d022";
export var bulletListStyle = "Typography-module--bullet--list-style--72567";
export var centerAlign = "Typography-module--center--align--2b075";
export var copy = "Typography-module--copy--c11ae";
export var greenColor = "Typography-module--green--color--12d0d";
export var heading = "Typography-module--heading--22623";
export var leftAlign = "Typography-module--left--align--d3f2f";
export var lgSpacing = "Typography-module--lg--spacing--cdc67";
export var lightWeight = "Typography-module--light--weight--560c4";
export var mdSpacing = "Typography-module--md--spacing--6c211";
export var noneListStyle = "Typography-module--none--list-style--4de19";
export var noneSpacing = "Typography-module--none--spacing--60f6c";
export var normalWeight = "Typography-module--normal--weight--0aa6a";
export var orangeColor = "Typography-module--orange--color--6ad5d";
export var prose = "Typography-module--prose--3bcd5";
export var rightAlign = "Typography-module--right--align--70fe4";
export var smSpacing = "Typography-module--sm--spacing--1e6f2";
export var whiteColor = "Typography-module--white--color--e29e1";